export interface IToken {
    expires: string;
    extraLayers: string;
    token: string;
}

export enum GeotelpaSessionStorage {
    Token = "geotelpatoken",
    ExtraLayers = "geotelpatokenextralayers",
    Expires = "geotelpatokenexpires"
}

export const getCurrentActiveToken = (): string => {
    const tokenExpiresDateString = sessionStorage.getItem(GeotelpaSessionStorage.Expires);
    const activeTokenExpiresDate = tokenExpiresDateString ? new Date(tokenExpiresDateString) : null;
    const now = new Date();
    return activeTokenExpiresDate && activeTokenExpiresDate > now
        ? sessionStorage.getItem(GeotelpaSessionStorage.Token)
        : null;
};

export const getTokenExtraLayers = (): string => {
    const tokenExpiresDateString = sessionStorage.getItem(GeotelpaSessionStorage.Expires);
    const activeTokenExpiresDate = tokenExpiresDateString ? new Date(tokenExpiresDateString) : null;
    const now = new Date();
    return activeTokenExpiresDate && activeTokenExpiresDate > now
        ? sessionStorage.getItem(GeotelpaSessionStorage.ExtraLayers)
        : null;
};

export const saveToken = (token: IToken) => {
    sessionStorage.setItem(GeotelpaSessionStorage.Token, token.token);
    sessionStorage.setItem(GeotelpaSessionStorage.ExtraLayers, token.extraLayers);
    sessionStorage.setItem(GeotelpaSessionStorage.Expires, token.expires);
};
